//#region IMPORT
import React from 'react';
/** Components Import */
import { Box, Stack, Typography } from '@mui/material';
import { Button, Dialog } from '../../../../Components/MUIs';
import ReactPlayer from 'react-player/lazy';
/** Icons Import */
import {
  Group as GroupIcon,
  QrCodeScanner as QrCodeScannerIcon,
} from '@mui/icons-material';
import QrCreator from '../../../../Components/QR-Code/QR-Creator/QrCreator';
import { useSelector } from 'react-redux';
import BackClickBottomSheetTbm from '../../../../Components/Ui/BackClickBottomSheetTbm';
//#endregion

function M_TBG_CUSTOM_01(props) {
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          영상 교육
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          영상을 재생하여 교육을 시작해주세요.
        </Typography>
      </Stack>
      {!props.inputs.video ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
          sx={{ minHeight: '300px' }}
        >
          <Typography variant="h5" fontWeight={550}>
            등록된 동영상이 없습니다.
          </Typography>
          <Typography variant="body1">관리자에게 문의하세요.</Typography>
        </Box>
      ) : (
        <Box sx={{ bgcolor: '#000000' }}>
          <ReactPlayer
            ref={props.videoRef}
            url={props.inputs.video}
            width="100%"
            controls={true}
            onEnded={props.HandleVideoEnd}
            onProgress={props.HandleProgress}
            onSeek={props.HandleSeek}
            onError={(e) => props.HandleVideoError(e)}
            progressInterval={100} // 100ms마다 onProgress 호출
            playing={props.play}
            style={{ minHeight: '300px' }}
          />
        </Box>
      )}
      <Stack
        sx={{
          p: 2,
          mt: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
        direction={'row'}
        spacing={3}
      >
        <Button
          variant="outlined"
          sx={{
            width: '100%',
            height: '36px',
            borderRadius: '18px',
            px: 0,
            border: 2,
            '&:hover': {
              border: 2,
            },
          }}
          name={
            <>
              <QrCodeScannerIcon sx={{ color: 'black' }} />
              <Typography sx={{ fontSize: '14px', color: '#575757' }}>
                QR 코드
              </Typography>
            </>
          }
          onClick={() => props.setModalToggle1(true)}
        />
        <Button
          sx={{
            width: '100%',
            height: '36px',
            borderRadius: '18px',
          }}
          // disabled={!props.inputs.isNext}
          name="완료"
          onClick={() => {
            props.ActiveButton({
              type: 'check1', // 동영상교육 완료
              id: props.userInfo.userid,
              content: true,
            });
            props.setActiveStep(props.activeStep + 1);
          }}
        />
      </Stack>
      {/* qr코드 모달 */}
      {props.modalToggle1 && (
        <Dialog
          title="교육 입장을 위한 QR 코드"
          open={props.modalToggle1}
          // onClose={(e) => props.setModalToggle1(false)}
          sx={{ height: '90vh' }}
          titleSx={{ fontSize: '18px', fontWeight: 'bold', pt: 3 }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
              maxWidth: '100%', // 혹시 모를 제한 제거
            },
          }}
          fullWidth={true}
          saveButtonName={
            props.lanList.length === 0
              ? ''
              : props.lanList.find(
                (f) => f.lanType === 'CALL' && f.lanId === 'Choice'
              ).lanNm
          } //선택
          closeButtonName={
            props.lanList.length === 0
              ? ''
              : props.lanList.find(
                (f) => f.lanType === 'CALL' && f.lanId === 'Close'
              ).lanNm
          } //닫기
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => { }}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <QrCreator value={props.qrcode} />
              <Box
                sx={{
                  p: 2,
                  gap: 0.5,
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                }}
              >
                <GroupIcon />
                <Typography>
                  {/* 전체 100명 중{" "} */}
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {props.userCount}명
                  </Typography>{' '}
                  참여 중
                </Typography>
              </Box>
              <Button
                sx={{
                  width: '100%',
                  height: '36px',
                  borderRadius: '18px',
                }}
                name={props.eduStart ? '완료' : '교육 시작'}
                onClick={() => {
                  if (props.eduStart) {
                    props.setModalToggle1(false);
                  } else {
                    props.SaveLogic1();
                    props.ActiveButton({
                      type: 'next',
                      content: true,
                      step: 1,
                    });
                    props.SaveLogic2([{ eStep: '1', mStep: '0', tbmCd: props.tbmCdRef.current }]);
                    props.setPlay(true);
                    props.setModalToggle1(false);
                    props.setEduStart(true);
                  }
                }}
              />
            </Box>
          }
        />
      )}
      {/* 바텀시트 부분 */}
      {bottomSheetState.type === 'backClickTbm' && (
        <BackClickBottomSheetTbm
          DeleteLogic={props.DeleteLogic1}
          ActiveButton={props.ActiveButton}
        />
      )}
    </>
  );
}

export default M_TBG_CUSTOM_01;
